
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Coins, Users, Home, User } from "lucide-react";
import {
  Sheet,
  SheetContent,
} from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { useAuth } from "@/lib/AuthContext";

interface AppSidebarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const AppSidebar = ({ open, setOpen }: AppSidebarProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const menuItems = [
    {
      name: "Home",
      path: "/home",
      icon: <Home className="h-5 w-5" />,
    },
    {
      name: "Chit Pools",
      path: "/chit-pools",
      icon: <Users className="h-5 w-5" />,
    },
    {
      name: "Loans",
      path: "/loans",
      icon: <Coins className="h-5 w-5" />,
    }
  ];

  const isActive = (path: string) => {
    return location.pathname.startsWith(path);
  };

  // Get user name from metadata
  const userName = user?.user_metadata?.name || user?.email?.split('@')[0] || 'User';
  // Get user initials for avatar
  const userInitials = userName.split(' ').map(n => n[0]).join('').toUpperCase();

  return (
    <>
      {/* Mobile sidebar only */}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="left" className="w-64 p-0 pt-10">
          <div className="flex justify-between items-center p-4 border-b">
            <h1 className="text-lg font-semibold">Chito</h1>
          </div>
          <div className="p-4 border-b">
            <div className="flex items-center gap-3">
              <Avatar className="h-8 w-8 bg-primary text-primary-foreground">
                <AvatarFallback>{userInitials}</AvatarFallback>
              </Avatar>
              <div>
                <p className="font-medium text-sm">{userName}</p>
              </div>
            </div>
          </div>
          <nav className="flex flex-col gap-2 p-4">
            {menuItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => setOpen(false)}
                className={cn(
                  "flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors",
                  isActive(item.path)
                    ? "bg-primary text-primary-foreground"
                    : "hover:bg-muted"
                )}
              >
                {item.icon}
                {item.name}
              </Link>
            ))}
          </nav>
        </SheetContent>
      </Sheet>
    </>
  );
};

export default AppSidebar;
